import {LayoutTeamCircles} from './LayoutTeamCircles';
import {LayoutTeamSlider} from './LayoutTeamSlider';

import {prebuiltLayoutPreviewImages} from '../constants';

const category = 'Team';

export const TeamCircles = {
  category,
  displayName: 'Team Circles',
  previewImageURL: prebuiltLayoutPreviewImages.layoutTeamCircles,
  layout: LayoutTeamCircles,
};

export const TeamSlider = {
  category,
  displayName: 'Team Slider',
  previewImageURL: prebuiltLayoutPreviewImages.layoutTeamSlider,
  layout: LayoutTeamSlider,
};
